import template from './heatmap.html';
import controller from './heatmap.controller';
import CalHeatMap from 'cal-heatmap';
import moment from 'moment';

// this is a directive because we need the link function, which components don't have
class HeatmapComponent {
  constructor() {
    "ngInject";
    this.restrict = "E";
    this.scope = {
      data: '<',
      config: '<',
      month: '<',
      year: '<'
    };
    this.controller = controller;
    this.template = template;
  }

  link(scope, el, attr) {

    let config = scope.config || {};

    let element = el[0];
    let cal = new CalHeatMap();
    let defaults = {
      itemSelector: element,
      animationDuration: 10
      // entities: 'month',
      // subDomain: 'x_day',
      // rowLimit: 7,
      // cellSize: 12,
      // considerMissingDataAsZero: true,
      // range: 12,
      // start: new Date(),
      // legend: [2, 4, 6, 8, 10],
      // itemName: 'item',


    };


    let x = {
      afterLoadData: function (timestamps) {
        var offset = new Date().getTimezoneOffset() * 60;
        var results = {};
        for (let timestamp in timestamps) {
          let commitCount = timestamps[timestamp];
          timestamp = parseInt(timestamp, 10);
          results[timestamp + offset] = commitCount
        }
        return results
      }
    };

    cal.init(Object.assign(defaults, config, x));

    // Function to update label text after heatmap renders
    const updateLabel = function() {
      setTimeout(function() {
        const labelElement = element.querySelector('.graph-label');
        if (labelElement && config.customLabelText) {
          labelElement.textContent = config.customLabelText;
        }
      }, 600);
    };

    // Add click event handler to show value on click
    const addClickHandlers = function() {
      setTimeout(function() {
        const cells = element.querySelectorAll('.graph-rect');
        cells.forEach(function(cell) {
          // Remove existing click handler to avoid duplicates
          cell.removeEventListener('click', handleCellClick);
          // Add click handler
          cell.addEventListener('click', handleCellClick);
        });
      }, 700);
    };

    // Handle cell click to show value
    const handleCellClick = function(event) {
      const cell = event.currentTarget;
      
      // Try to get date from various possible attributes
      let dateAttr = cell.getAttribute('data-date') || 
                     cell.getAttribute('data-timestamp') ||
                     cell.getAttribute('data-count');
      
      // Try to get value from various possible attributes or from the data
      let valueAttr = cell.getAttribute('data-value') || 
                      cell.getAttribute('data-count') ||
                      cell.getAttribute('title');
      
      // If we have a date attribute, try to parse it
      if (dateAttr) {
        let date;
        let value = 0;
        
        // Try parsing as timestamp (seconds)
        const timestamp = parseInt(dateAttr, 10);
        if (!isNaN(timestamp)) {
          date = moment(timestamp * 1000);
          // Try to get value from the data object
          if (scope.data && scope.data[timestamp]) {
            value = parseFloat(scope.data[timestamp]) || 0;
          } else if (valueAttr) {
            value = parseFloat(valueAttr) || 0;
          }
        } else {
          // Try parsing as date string
          date = moment(dateAttr);
        }
        
        if (date && date.isValid()) {
          const formattedDate = date.format('MMM DD, YYYY');
          const formattedValue = value.toFixed(2);
          const itemName = config.itemName || 'hour';
          
          // Show alert with the value
          alert(`${formattedDate}: ${formattedValue} ${itemName}${value !== 1 ? 's' : ''}`);
        }
      } else {
        // Fallback: try to get info from title attribute
        const title = cell.getAttribute('title');
        if (title) {
          alert(title);
        }
      }
    };

    scope.$watch('data', (newVal, oldVal) => {

      let m = scope.month + 1;
      cal.jumpTo(moment(m +'-01-'+scope.year, 'MM-DD-YYYY').toDate(), true);

      setTimeout(function() {
        cal.update(newVal);
        updateLabel();
        addClickHandlers();
      }, 500);


    }, true)
    
    // Watch for config changes to update label
    scope.$watch('config.customLabelText', function(newVal) {
      if (newVal) {
        updateLabel();
      }
    });
  }
}

export default HeatmapComponent;



// WEBPACK FOOTER //
// ./client/common/directives/heatmap/heatmap.component.js